
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LogIn } from 'lucide-react';
import { Button } from '@/components/ui/button';

const LoginButton: React.FC = () => {
  const navigate = useNavigate();
  
  return (
    <Button 
      variant="outline" 
      size="sm" 
      onClick={() => navigate('/auth')}
      className="flex items-center gap-1"
    >
      <LogIn className="h-4 w-4" />
      Přihlásit
    </Button>
  );
};

export default LoginButton;
